var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Plus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 238,
    viewBox: "0 0 238 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119 39.6667C162.815 39.6667 198.333 75.1849 198.333 119C198.333 162.815 162.815 198.333 119 198.333C75.1849 198.333 39.6667 162.815 39.6667 119C39.6667 75.1849 75.1849 39.6667 119 39.6667ZM145.444 128.917C150.922 128.917 155.361 124.477 155.361 119C155.361 113.523 150.922 109.083 145.444 109.083C144.357 109.083 137.425 109.083 128.917 109.083C128.917 100.575 128.917 93.6398 128.917 92.5555C128.917 87.0782 124.477 82.6389 119 82.6389C113.523 82.6389 109.083 87.0782 109.083 92.5555C109.083 93.6398 109.083 100.575 109.083 109.083C100.575 109.083 93.6431 109.083 92.5556 109.083C87.0783 109.083 82.6389 113.523 82.6389 119C82.6389 124.477 87.0783 128.917 92.5556 128.917C93.6431 128.917 100.575 128.917 109.083 128.917C109.083 137.425 109.083 144.36 109.083 145.444C109.083 150.922 113.523 155.361 119 155.361C124.477 155.361 128.917 150.922 128.917 145.444C128.917 144.36 128.917 137.425 128.917 128.917C137.425 128.917 144.357 128.917 145.444 128.917Z",
    fill: "url(#paint0_linear_231_175)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_175",
    x1: 198.333,
    y1: 88.2061,
    x2: 10.4386,
    y2: 144.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A360D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876978,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Plus1);
export default __webpack_public_path__ + "static/media/icons8-plus1.6b803a63d8fcacb0cc0f64371f217289.svg";
export { ForwardRef as ReactComponent };